import { validateForm } from "../services/sendFormB2B";
import { $Q, $Qll } from "../utils/query-selector"

const printPoints = (container, points, costCondition) => {
  const b2bCustomer = $Q("#b2bCustomer", container).value;
  const isModal = $Q("#isModal", container).value;
  const pointsContainer = $Q("#points", container);
  const costConditionContainer = $Q("#cost_condition", container);

  if (points <= 0) {
    pointsContainer.closest('.points-message').setAttribute('hidden', '');
    return
  }

  pointsContainer.closest('.points-message').removeAttribute('hidden');

  if (b2bCustomer === "true") {
    pointsContainer.innerHTML = `<span class="compare">${points}</span> ${points * 2}`;
    costCondition = costCondition * 2
  } else {
    pointsContainer.innerText = points;
  }

  costConditionContainer.innerText = `${costCondition.toFixed(2).replace(".", ",")} €`
}

const calculatePoints = (container, price, cost) => {
  const pointsMultiplier = $Q("#pointsMultiplier", container).value;
  const costMultiplier = $Q("#costMultiplier", container).value;

  const profit = price - cost;
  const points = Math.round(profit * parseFloat(pointsMultiplier));
  const costCondition = points * parseFloat(costMultiplier);

  printPoints(container, points, costCondition)
}

export const rewardPoints = () => {
  const messageContainer = $Qll(".points-message");

  if (messageContainer.length > 0) {

    messageContainer.forEach(async (container) => {
      const price = $Q("#formattedPrice", container).value;
      const formattedPrice = parseFloat(price.replace(",", "."));
      const variantId = $Q("#pointsVariant", container).value;

      const formData = {
        productVariantID: variantId,
      }

      if (variantId !== "") {
        const response = await validateForm("/v1/productPrice", formData);

        if (!response?.cost) {

          container.parentNode.setAttribute("hidden", true);
          return;
        }

        container.parentNode.removeAttribute("hidden");

        const cost = parseFloat(response.cost);
        calculatePoints(container, formattedPrice, cost);
      }
    });
  }
}
